import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M14 15h1', key: '171nev' }],
  ['path', { d: 'M14 9h1', key: 'l0svgy' }],
  ['path', { d: 'M19 15h2', key: '1vnucp' }],
  ['path', { d: 'M19 9h2', key: 'te2zfg' }],
  ['path', { d: 'M3 15h2', key: '8bym0q' }],
  ['path', { d: 'M3 9h2', key: '1h4ldw' }],
  ['path', { d: 'M9 15h1', key: '1tg3ks' }],
  ['path', { d: 'M9 9h1', key: '15jzuz' }],
  ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', key: 'h1oib' }],
];

/**
 * @component @name PanelTopBottomDashed
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTVoMSIgLz4KICA8cGF0aCBkPSJNMTQgOWgxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxNWgyIiAvPgogIDxwYXRoIGQ9Ik0xOSA5aDIiIC8+CiAgPHBhdGggZD0iTTMgMTVoMiIgLz4KICA8cGF0aCBkPSJNMyA5aDIiIC8+CiAgPHBhdGggZD0iTTkgMTVoMSIgLz4KICA8cGF0aCBkPSJNOSA5aDEiIC8+CiAgPHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/panel-top-bottom-dashed
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const PanelTopBottomDashed = createLucideIcon('panel-top-bottom-dashed', __iconNode);

export default PanelTopBottomDashed;
